// C1: Room 右键浮层菜单 —— 重命名 / 清空历史 / 删除
//
// 定位策略：fixed 跟随 e.clientX/Y，溢出屏幕时夹紧到视口内。
// 点空白处 / Esc 关闭。

import { useEffect, useRef } from "react";

import type { StoredRoom } from "../lib/storage";

interface Props {
  x: number;
  y: number;
  room: StoredRoom;
  onRename: (r: StoredRoom) => void;
  onClearHistory: (r: StoredRoom) => void;
  onDelete: (r: StoredRoom) => void;
  onDismiss: () => void;
}

export function RoomContextMenu({
  x,
  y,
  room,
  onRename,
  onClearHistory,
  onDelete,
  onDismiss,
}: Props) {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onDismiss();
    };
    const onClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onDismiss();
    };
    window.addEventListener("keydown", onKey);
    window.addEventListener("mousedown", onClickOutside);
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("mousedown", onClickOutside);
    };
  }, [onDismiss]);

  // 防溢出
  const w = 180;
  const h = 130;
  const left = Math.min(x, window.innerWidth - w - 4);
  const top = Math.min(y, window.innerHeight - h - 4);

  return (
    <div
      ref={ref}
      className="room-ctx-menu"
      style={{ left, top }}
      role="menu"
      aria-label={`会话 ${room.name} 操作`}
    >
      <button
        type="button"
        className="room-ctx-menu__item"
        onClick={() => onRename(room)}
      >
        重命名
      </button>
      <button
        type="button"
        className="room-ctx-menu__item"
        onClick={() => onClearHistory(room)}
      >
        清空历史
      </button>
      <div className="room-ctx-menu__sep" />
      <button
        type="button"
        className="room-ctx-menu__item room-ctx-menu__item--danger"
        onClick={() => onDelete(room)}
      >
        删除会话
      </button>
    </div>
  );
}
